
export enum ReportPresetType {
    Public = "public",
    Private = "private"
}
